import * as React from 'react';

/** Props for the {@link AvatarWaves} component. */
interface AvatarWavesProps {
  /** Which side of the avatar to render the waves on. */
  side: 'left' | 'right';
}

/**
 * Decorative arc waves rendered beside an avatar circle.
 * Renders an outer arc and an inner arc on the specified side.
 */
export const AvatarWaves: React.FC<AvatarWavesProps> = React.memo(({ side }) => {
  const isLeft = side === 'left';
  const positionKey = isLeft ? 'left' : 'right';
  const mirror = isLeft ? 'scaleX(-1)' : undefined;

  return (
    <div className='pointer-events-none absolute left-0 top-0 size-full'>
      {/* Outer arc */}
      <div
        className='absolute'
        style={{
          [positionKey]: '-13px',
          top: '11px',
          height: '30px',
          width: '14px',
          transform: mirror,
        }}
      >
        <svg width='100%' height='100%' viewBox='0 0 14 30' fill='none'>
          <path
            d='M 2 2 A 26 26 0 0 1 2 28'
            stroke='#BFB0F8'
            strokeWidth='3.5'
            strokeLinecap='round'
            fill='none'
          />
        </svg>
      </div>
      {/* Inner arc */}
      <div
        className='absolute'
        style={{
          [positionKey]: '-18px',
          top: '19px',
          height: '14px',
          width: '10px',
          transform: mirror,
        }}
      >
        <svg width='100%' height='100%' viewBox='0 0 10 14' fill='none'>
          <path
            d='M 2 2 A 26 26 0 0 1 2 12'
            stroke='#BFB0F8'
            strokeWidth='3.5'
            strokeLinecap='round'
            fill='none'
          />
        </svg>
      </div>
    </div>
  );
});

AvatarWaves.displayName = 'AvatarWaves';
